import React from 'react';

export const DeveloperMenu = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ alignSelf: 'center' }}>Dev</div>
      <>🛠</>
    </div>
  );
};

export const ImpersonateMenu = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ alignSelf: 'center' }}>Impersonate</div>
      <>🚶‍♀️</>
    </div>
  );
};
